import { useEffect, useRef, useState } from "react";
import { getMenuWidth } from "../../../utils/getWindowDimensions";
import { chartStdWidth } from "../../../data/main";
import Chart from "./Graph";
import { stdObject } from "../../../data/types/stdObject";
import { sendData } from "../../../services/sendData";
import { useMainContext } from "../../../context/MainContext";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";

export default function GraphsBox() {
  const draggedIndex = useRef(-1);
  const [chartsInfoList, setChartsInfoList] = useState<stdObject[]>([]);
  const [itemWidth, setItemWidth] = useState<number>(getMenuWidth());
  const divRef = useRef<HTMLDivElement | null>(null);
  const user: any = useSelector((state: RootState) => state.data.user);
  const { setMsg, logoutAction, closeMsg } = useMainContext();

  useEffect(() => {
    findCharts();
    correctWidth();
    const observer = new ResizeObserver(correctWidth);

    if (divRef.current) {
      observer.observe(divRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  const findCharts = async () => {
    setMsg("loading");
    const payloadCharts = { usercode: user.CODUSU, rolcode: user.ROLUSU };

    const responseCharts: stdObject = await sendData({
      endPoint: "callCharts",
      payload: payloadCharts,
      logoutAction,
    });

    const { success, status, chartsList } = responseCharts;
    if (success && status) {
      setChartsInfoList(chartsList);
      closeMsg();
      return true;
    } else {
      setMsg("error");
    }
  };

  const sortCharts = async (data: stdObject[]) => {
    setMsg("loading");
    const payloadSortCharts = {
      data: data.map((e: stdObject) => e.CODCHR),
    };
    console.log("payloadSortCharts", payloadSortCharts);
    await sendData({
      endPoint: "sortCharts",
      payload: payloadSortCharts,
      logoutAction,
    });
    closeMsg();
  };

  const correctWidth = () => {
    if (divRef.current) {
      let units = Math.trunc(divRef.current.clientWidth / chartStdWidth);
      let tempWidth = divRef.current.clientWidth - (30 + (units - 1) * 15);
      let tempItemWidth = tempWidth / units - 0.5;
      if (itemWidth !== tempItemWidth) {
        setItemWidth(tempItemWidth);
      }
    }
  };

  const handleDragStart = (index: number) => {
    draggedIndex.current = index;
  };

  const handleDrop = (index1: number) => {
    const index0 = draggedIndex.current;

    setChartsInfoList((currentList) => {
      const sortData = [
        currentList.findIndex((v: stdObject) => v.CODCHR === index0),
        currentList.findIndex((v: stdObject) => v.CODCHR === index1),
      ];
      [currentList[sortData[0]], currentList[sortData[1]]] = [
        currentList[sortData[1]],
        currentList[sortData[0]],
      ];
      sortCharts([...currentList]);
      return [...currentList];
    });
    draggedIndex.current = -1;
  };

  return (
    <div ref={divRef} className="listBox">
      <div className="wrapBox">
        {chartsInfoList.map((e) => (
          <Chart
            key={e.CODCHR}
            code={e.CODCHR}
            width={itemWidth}
            handleDragStart={handleDragStart}
            handleDrop={handleDrop}
          />
        ))}
      </div>
    </div>
  );
}
